module.exports = __webpack_public_path__ + "img/FamilyOfficeIcon.8f4c4bc7.svg";